import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import * as reporter from "./report";
var cookieLoaderIframeId = 'login_cookie_cross_domain_frame_v2';
var cookiePageUrl = 'https://video.qq.com/cookie/1.0.0/cookie.html';
var messageSource = 'VIDEO_SYNC';
var timeout = 3000;
var IframeCookieLoader = /*#__PURE__*/function () {
  function IframeCookieLoader() {
    _classCallCheck(this, IframeCookieLoader);
    _defineProperty(this, "eventHandlers", {});
    _defineProperty(this, "messageQueues", []);
    _defineProperty(this, "timers", {});
    this.initTime = Date.now();
    this.initIframe();
    this.initEvents();
  }
  _createClass(IframeCookieLoader, [{
    key: "initEvents",
    value: function initEvents() {
      var _this = this;
      window.addEventListener('message', function (e) {
        var _e$data;
        if ((e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.source) !== messageSource) return;
        var _e$data2 = e.data,
          event = _e$data2.event,
          action = _e$data2.action,
          data = _e$data2.data;
        if (event === 'ready') {
          _this.isFrameReady = true;
          _this.execQueues();
          reporter.report({
            f_event: reporter.EVENT_INIT_COOKIE_READY,
            f_cost: Date.now() - _this.initTime
          });
        } else if (event === 'action-callback') {
          _this.execEvents(action, data);
        }
      });
    }
  }, {
    key: "execQueues",
    value: function execQueues() {
      var _this2 = this;
      if (!this.messageQueues.length) return;
      this.messageQueues.forEach(function (message) {
        _this2.postMessage(message);
      });
    }
  }, {
    key: "emit",
    value: function emit(action) {
      var _this3 = this;
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return new Promise(function (resolve, reject) {
        if (!_this3.eventHandlers[action]) {
          _this3.eventHandlers[action] = [];
        }
        _this3.eventHandlers[action].push(resolve);
        _this3.postMessage({
          action: action,
          source: messageSource
        });
        // 调用超时情况
        if (timeout > 0) {
          _this3.timers[action] = setTimeout(function () {
            reject(new Error('cookie sync timeout'));
            delete _this3.eventHandlers[action];
          }, timeout);
        }
      });
    }
  }, {
    key: "postMessage",
    value: function () {
      var _postMessage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(message) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.iframe) {
                  _context.next = 3;
                  break;
                }
                _context.next = 3;
                return this.initIframe();
              case 3:
                if (!this.isFrameReady) {
                  this.messageQueues.push(message);
                } else {
                  this.iframe.contentWindow.postMessage(message, '*');
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function postMessage(_x) {
        return _postMessage.apply(this, arguments);
      }
      return postMessage;
    }()
  }, {
    key: "execEvents",
    value: function execEvents(action, data) {
      if (!this.eventHandlers[action]) return;
      var handlers = this.eventHandlers[action];
      if (!handlers.length) return;
      handlers.forEach(function (handler) {
        handler(data);
      });
      this.timers[action] && clearTimeout(this.timers[action]);
    }
  }, {
    key: "getVideoCookie",
    value: function getVideoCookie() {
      return this.emit('getCookies', timeout);
    }
  }, {
    key: "clearVideoCookie",
    value: function clearVideoCookie() {
      return this.emit('clearCookies', timeout);
    }
  }, {
    key: "initIframe",
    value: function initIframe() {
      var _this4 = this;
      this.iframe = document.getElementById(cookieLoaderIframeId);
      this.isLoading = true;
      if (!this.iframe) {
        var iframe = document.createElement('iframe');
        iframe.id = cookieLoaderIframeId;
        iframe.style.display = 'none';
        this.iframe = iframe;
        document.body.appendChild(iframe);
      }
      this.iframe.src = "".concat(cookiePageUrl, "?_t=").concat(Date.now());
      this.iframe.onload = function () {
        _this4.isLoading = false;
        reporter.report({
          f_event: reporter.EVENT_INIT_COOKIE_ONLOAD,
          f_cost: Date.now() - _this4.initTime
        });
      };
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.instance) {
        this.instance = new IframeCookieLoader();
      }
      return this.instance;
    }
  }]);
  return IframeCookieLoader;
}();
_defineProperty(IframeCookieLoader, "instance", void 0);
export { IframeCookieLoader as default };